// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "@fortawesome/fontawesome-pro/js/all"
import * as bootstrap from "bootstrap"
import TomSelect from "tom-select"

// Stimulus
import "./controllers/index.js"
